// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__3pfcD","main":"Main_main__2lLek","main-content":"Main_main-content__3OzY6","small-margin":"Main_small-margin__3scld"};